


import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import PresetMedia from '../PresetMedia/index.vue';
import { Preset as IPreset } from '@/utils/api';

@Component({
  components: {
    PresetMedia
  }
})
export default class Preset extends Vue {
  @Prop({}) private preset!: IPreset;
  @Prop({}) private presetIndex!: number;
  @Prop({}) private presetNumber!: number;

  @Emit()
  private selectPreset() {
    return;
  }

  /**
   * Replace line endings with the according HTML code.
   */
  public descriptionWithLineBreaks() {
    return this.preset.description.replace('\n', '<br />');
  }
}
